import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import PaymentImage from "../../assets/Onboarding/PaymentImage.png"


export default function OnBoaringMainPage({enableAccount}) {
  const { user } = useAuthContext();
  const [account,setAccount] = useState();
  const [isLoading,setIsLoading] = useState(true)
  

  useEffect(() => {
getAccount();
  },[])

  const createAccount = async () => {
    setIsLoading(true);
    try {
      const createAccResponse = await axios.post(
        `${ApiConnectionString}/api/ConnectAccount`,
        null,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (createAccResponse.status === 200) {
        window.location.href = createAccResponse.data.link;
      }
    } catch (error) {
      console.error("Account creation failed:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  
  const getAccount = async () => {
    setIsLoading(true);
    try {
      const getAccRespose = await axios.get(
        `${ApiConnectionString}/api/ConnectAccount`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (getAccRespose.status === 200) {
        if (getAccRespose.data === "Account is enabled and ready to use") {
          enableAccount();
        } else {
          setAccount(getAccRespose.data);
        }
      }
    } catch (error) {
      console.error("Error getting account:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  const reviewAccount = async () => {
    setIsLoading(true);
    try {
      const createAccRespose = await axios.post(
        `${ApiConnectionString}/api/ConnectAccount/Review`,
        null,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (createAccRespose.status === 200) {
        window.location.href = createAccRespose.data.link;
      }
    } catch (error) {
      console.error("Error reviewing account:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  if(isLoading){
    return(
      <div>
        <LoadingSpinner />
      </div>
    )
  }


return (
  <div className="container my-5">
    <div className="bg-white rounded shadow-sm p-4">
      <h2 className="mb-4 text-center fw-bold blueText">Onboarding</h2>

      <div className="row">
        <div className="col-12 col-lg-5 text-center mb-4 mb-lg-0">
          <img
            src={PaymentImage}
            alt="Payment Illustration"
            className="img-fluid payment-image"
          />
        </div>

        <div className="col-12 col-lg-7 mt-lg-0 text-center">
          <h5 className="fw-semibold">
            To create a club, you must first create a Stripe account linked to Membotic.
          </h5>
          <p className="text-muted">
            Stripe is a secure payment platform that enables you to receive payments from your club members.
          </p>

          <div className="mb-3">
            {account === "No Account" && (
              <button onClick={createAccount} className="saveChanges-button fw-bold">
                Connect with Stripe
              </button>
            )}
            {account === "Account not fully enabled" && (
              <button onClick={reviewAccount} className="saveChanges-button fw-bold">
                Review Stripe Account
              </button>
            )}
          </div>

          <p className="text-muted mt-3 small d-flex ">
       
            Membotic does not store payment details. All transactions are securely handled by Stripe.
          </p>
        </div>
      </div>
    </div>
  </div>
);

}